/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const BellIconFor = (props: Props) => (
  <svg
    viewBox="0 0 25 23"
    onClick={props.onClick}
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
      <g id="Untitled" transform="translate(0.000000, 1.000000)" stroke="#ffffff">
        <path
          d="M21.7916667,15.0652174 L21.7916667,10.0434783 C21.7916667,6.70995652 19.6750833,3.87495652 16.7124167,2.77656522 C16.5098333,1.4636087 15.375,0.45652174 14,0.45652174 C12.625,0.45652174 11.4865,1.4636087 11.2839167,2.77656522 C8.32125,3.87495652 6.20833333,6.70995652 6.20833333,10.0434783 L6.20833333,15.0652174 C6.20833333,16.5781304 4.97633333,17.8043478 3.45833333,17.8043478 L24.5416667,17.8043478 C23.0209167,17.8043478 21.7916667,16.5781304 21.7916667,15.0652174 Z"
          id="Shape"
          fillRule="nonzero"
        />
        <path
          d="M16.75,17.8043478 C16.75,19.3172609 15.518,20.5434783 14,20.5434783 C12.47925,20.5434783 11.25,19.3172609 11.25,17.8043478"
          id="Shape"
          fillRule="nonzero"
        />
        <g
          id="Group"
          transform="translate(7.505469, 11.511734) rotate(179.910328) translate(-7.505469, -11.511734) translate(0.005469, 8.011734)"
          strokeLinecap="round"
        >
          <path d="M0.5,3.5 L14.5,3.5" id="Line" />
          <path d="M14.5,3.5 L11.5,6.5" id="Line-3" />
          <path d="M14.5,3.5 L11.5,0.5" id="Line-3" />
        </g>
      </g>
    </g>
  </svg>
);

export default BellIconFor;
